import http from "./http";
const expert = {

  //可操作的科目列表
  mySubjectList() {
    return http.post("expert/article/mySubject", {});
  },

  //稿件池
  articleListGJC(f_subjectId,f_title, order, sort, page, size) {
    return http.post("expert/article/article_unaudited?f_subjectId="+f_subjectId+"&f_title="+f_title+"&order=" +
    order +
    "&sort=" +
    sort +
    "&page=" +
    page +
    "&size=" +
    size, {});
  },

  //待评审稿件
  articleListAudit(f_subjectId,f_title, order, sort, page, size) {
    return http.post("expert/article/article_audit?f_subjectId="+f_subjectId+"&type=1&f_title="+f_title+"&order=" +
    order +
    "&sort=" +
    sort +
    "&page=" +
    page +
    "&size=" +
    size, {});
  },

  //已评审稿件
  articleListAudited(f_subjectId,f_title, order, sort, page, size) {
    return http.post("expert/article/article_audit?f_subjectId="+f_subjectId+"&type=2&f_title="+f_title+"&order=" +
    order +
    "&sort=" +
    sort +
    "&page=" +
    page +
    "&size=" +
    size, {});
  },

  //批量锁定稿件，加入购物车
  addArticlesToCart(articleIds){
    return http.post("expert/article/locks?typeId=1",{articleIds:articleIds});
  },

  //批量取消锁定稿件，移出购物车
  removeArticlesFromCart(articleIds){
    return http.post("expert/article/locks?typeId=2",{articleIds:articleIds});
  },

  //锁定稿件，加入购物车
  addArticleToCart(articleId){
    return http.post("expert/article/lock?typeId=1&articleId="+articleId,{});
  },

  //取消锁定稿件，移出购物车
  removeArticleFromCart(articleId){
    return http.post("expert/article/lock?typeId=2&articleId="+articleId,{});
  },

  //获取稿件运行流程
  getArticleProcessList(articleId){
    return http.get("expert/article/processList?articleId="+articleId);
  },

  //审稿
  doAudit(articleId,idea,remark,attachId){
    let modal = {
      articleId:articleId,
      opinion:idea,
      remark:remark,
      attachId:attachId,
    };
    return http.post("expert/audit/edit",modal);
  },
};
export default expert;
